import { Box, Button, Slider } from "@mui/material";
import React, { useState } from "react";
import SvgRuler from "./svgRuler";
import './selectMoj.scss'

const SelectMoj = ({ draft, setDraft, submit }) => {
  const [activeSlider, setActiveSlider] = useState(1);

  const handleSubmit = () => {    
    const newDraft = {
      ...draft,
      band: activeSlider,
    }
    setDraft(newDraft);
    submit(newDraft);
  };


  return (
    <>
      <Box
      style={{
        width: "100%",
        height: "78%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        }}
      >
        <div style={{ position: "relative" }}>
          <div className="picMoj">
            <SvgRuler activeSlide={activeSlider} />
          </div>
          <div
            style={{
              position: "absolute",
              left: "0%",
              top: "0%",
              color: "white",
              fontSize: "8px",
              width: "100%",
              height: "95%",
              backgroundColor: "transparent",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "82%",
                paddingLeft: "10px",
                paddingRight: "10px",
                height: "32%",
              }}
            >
              <Slider
                aria-label="Temperature"
                defaultValue={0}
                shiftStep={1}
                step={1}
                marks
                min={1}
                max={6}
                valueLabelDisplay="off"
                sx={{ height: "100%", color: "transparent" }}
                onChange={(e) => setActiveSlider(e.target.value)}
              />
            </Box>
          </div>
        </div>

    </Box>
        <Button className="button-save" onClick={handleSubmit}>Create</Button>
        </>
  );
};

export default SelectMoj;
